import { GET_ALL_LISTINGS} from './types';
import listingsSearchService from '../../components/Services/listingsSearch.service';

export const getAllListingsGeneratorLogin = (reqBody) => async (dispatch) => {
              listingsSearchService.getAllConsumerCapacity(reqBody)
              .then((response) => {
                if (response && response.data.code === 200) {
                    dispatch({ type: GET_ALL_LISTINGS, payload: response?.data?.data });
                }
              }).catch(err => console.log(err))
}
export const getAllListingsConsumerLogin = (reqBody) => async (dispatch) => {
        listingsSearchService.getAllGeneratorCapacity(reqBody)
          .then((response) => {
            if (response && response.data.code === 200) {
                dispatch({ type: GET_ALL_LISTINGS, payload: response?.data?.data });
            }
          }).catch(err => console.log(err))
}

export const getTraderGenerator = () => async (dispatch) => {
  listingsSearchService
    .getAllGeneratorCapacity()
    .then((response) => {
      if (response && response.data.code === 200) {
        dispatch({ type: GET_ALL_LISTINGS, payload: response?.data?.data });
      }
    })
    .catch((err) => console.log(err));
};

export const getTraderConsumer = () => async (dispatch) => {
  listingsSearchService
    .getAllConsumerCapacity()
    .then((response) => {
      if (response && response.data.code === 200) {
        dispatch({ type: GET_ALL_LISTINGS, payload: response?.data?.data });
      }
    })
    .catch((err) => console.log(err));
};
